/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { CellValue } from "../../types/CellValue";
export const BulkUpdateRecordRequest = core.serialization.object({
    fieldUpdates: core.serialization.record(core.serialization.string(), CellValue),
});
